/**
 * Routine Showcase Section JavaScript
 * Handles step navigation and interactive functionality
 */

class RoutineShowcase {
	constructor(container) {
		this.container = container || document
		this.init()
	}

	init() {
		// Check if required elements exist before proceeding
		if (!this.container.querySelector(".routine-showcase__progress-step")) {
			return
		}

		this.bindEvents()
		this.setupInitialState()
	}

	bindEvents() {
		// Bind step navigation buttons
		const stepButtons = this.container.querySelectorAll(".routine-showcase__progress-step")
		if (stepButtons.length > 0) {
			stepButtons.forEach(button => {
				button.addEventListener("click", e => this.handleStepClick(e))
			})
		}

		// Bind accordion functionality
		const accordions = this.container.querySelectorAll(".routine-showcase__accordion")
		if (accordions.length > 0) {
			accordions.forEach(accordion => {
				const summary = accordion.querySelector("summary")
				if (summary) {
					summary.addEventListener("click", e => this.handleAccordionClick(e, accordion))
				}
			})
		}
	}

	setupInitialState() {
		// Ensure first step is active by default
		const firstStep = this.container.querySelector(".routine-showcase__step")
		const firstButton = this.container.querySelector(".routine-showcase__progress-step")

		if (firstStep && firstButton) {
			// Remove active class from all steps first
			const allSteps = this.container.querySelectorAll(".routine-showcase__step")
			allSteps.forEach(step => {
				step.classList.remove("active")
				step.setAttribute("aria-hidden", "true")
			})

			// Set first step as active
			firstStep.classList.add("active")
			firstStep.setAttribute("aria-hidden", "false")
			firstButton.classList.add("active")
			firstButton.setAttribute("aria-current", "true")
		}
	}

	handleStepClick(event) {
		const button = event.currentTarget
		const stepNumber = button.getAttribute("data-step")

		if (!stepNumber) return

		// Update active states
		this.updateActiveStep(stepNumber)
		this.updateActiveButton(button)
	}

	updateActiveStep(stepNumber) {
		console.log("Switching to step:", stepNumber)

		// Hide all steps
		const allSteps = this.container.querySelectorAll(".routine-showcase__step")
		console.log("Total steps found:", allSteps.length)

		if (allSteps.length > 0) {
			allSteps.forEach((step, index) => {
				const stepData = step.getAttribute("data-step")
				console.log(`Step ${index}: data-step="${stepData}", classes="${step.className}"`)
				step.classList.remove("active")
				step.setAttribute("aria-hidden", "true")
			})
		}

		// Show target step - specifically look for step content, not progress buttons
		const targetStep = this.container.querySelector(
			`.routine-showcase__step[data-step="${stepNumber}"]`
		)
		console.log("Target step found:", targetStep)

		if (targetStep) {
			targetStep.classList.add("active")
			targetStep.setAttribute("aria-hidden", "false")
			console.log("Target step is now active, classes:", targetStep.className)			
		} else {
			console.error("ERROR: Target step not found for step number:", stepNumber)
		}

		// Update progress line to show current step
		const progressLine = this.container.querySelector(".routine-showcase__progress-line")
		if (progressLine) {
			progressLine.setAttribute("data-step", stepNumber)
		}

		// Handle product card title heights if applicable		
		requestAnimationFrame(() => {
			this.handleProductCardTitles(targetStep)
		})
	}

	updateActiveButton(activeButton) {
		// Remove active state from all buttons
		const allButtons = this.container.querySelectorAll(".routine-showcase__progress-step")
		if (allButtons.length > 0) {
			allButtons.forEach(button => {
				button.classList.remove("active")
				button.setAttribute("aria-current", "false")
			})
		}

		// Add active state to clicked button
		activeButton.classList.add("active")
		activeButton.setAttribute("aria-current", "true")
	}

	handleAccordionClick(event, accordion) {
		// Prevent default behavior to handle manually
		event.preventDefault()

		// Toggle accordion state
		const isOpen = accordion.hasAttribute("open")

		if (isOpen) {
			accordion.removeAttribute("open")
		} else {
			accordion.setAttribute("open", "")
		}
	}

	handleProductCardTitles(targetContainer) {
		let productCards = targetContainer.querySelectorAll('.product-card');		
		
		let cardHeight
		productCards.forEach((card, i) => {
			let cardsSameEl = card.parentElement.querySelectorAll('.product-card');
			
			let cardsSameRow = [];
			cardsSameEl.forEach((el) => {
			if (card.offsetTop === el.offsetTop) {
				cardsSameRow.push(el);
			}
			});
			
			cardHeight = Math.max(...cardsSameRow.map((el) => el.querySelector('.product-title.product-card__title').offsetHeight));
			cardsSameRow.forEach((el) => {
				el.querySelector('.product-title.product-card__title').style.setProperty('min-height', `${cardHeight}px`);
			});
		});
	}
}

// Initialize when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
	// Find all routine showcase sections and initialize each one
	const showcaseSections = document.querySelectorAll(".routine-showcase")
	if (showcaseSections.length > 0) {
		showcaseSections.forEach(section => {
			new RoutineShowcase(section)
		})
	}
})

// Also initialize for Shopify's section rendering
document.addEventListener("shopify:section:load", event => {
	if (event.target.classList.contains("routine-showcase")) {
		new RoutineShowcase(event.target)
	}
})

// Initialize for Shopify's section rendering when sections are re-rendered
document.addEventListener("shopify:section:reorder", event => {
	if (event.target.classList.contains("routine-showcase")) {
		new RoutineShowcase(event.target)
	}
})
